import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";

function Activity({ log }: Props) {
  const { t } = useTranslation();

  return (
    <div>
      {log.content.includes("update") ? (
        <p>
          {t(
            `planzoneLogsPage.description.${log.content}.${log.attributes.target}`,
            {
              name: t(
                `projectStatuses.${log.attributes.data}`,
                log.attributes.data,
              ),
              parent:
                (log.logType === "TASK" ||
                  log.logType === "EVENT" ||
                  log.logType === "MILESTONE" ||
                  log.logType === "ACTIVITY" ||
                  log.logType === "PROJECT") &&
                log.project
                  ? log.project.name
                  : log.attributes.parent,
            },
          )}
        </p>
      ) : (
        <p>
          {t(`planzoneLogsPage.description.${log.content}`, {
            name: log.attributes.data,
            parent:
              (log.logType === "TASK" ||
                log.logType === "EVENT" ||
                log.logType === "MILESTONE" ||
                log.logType === "ACTIVITY" ||
                log.logType === "PROJECT") &&
              log.project
                ? log.project.name
                : log.attributes.parent,
          })}
        </p>
      )}
    </div>
  );
}

export { Activity };
